import * as Toolkit from '../../../toolkit/index';
import * as CubeTree from '../../../cubeTree/index';
import FrontCubeData from '../../../frontCubeData/index';
import CodiSystem from '../../../codiSystem/index';
import Config from '../../../config/index';
import Utils from '../../../utils/util';

const defaultLayerHeight: LogicsicsMeasurement = Toolkit.cmToPx(Config.get({
    moduleName: 'layer',
    key: 'defaultLayerHeight'
}));

function findTargetShelf(shelfsCoordinate: CubePaintCoordinate[], mousePoint: MousePoint, dragCubes: CubeId[]): CubeId|null {
    let skip: Set<CubeId> = new Set(dragCubes);

    for(let i = 0; i < shelfsCoordinate.length; i++) {
        let coordinate: CubePaintCoordinate = shelfsCoordinate[i];
        if (skip.has(coordinate.id)) {
            continue;
        }
        let point: MousePoint = {
            ...mousePoint
        };
        let rect: Rect = {
            left: coordinate.left,
            top: coordinate.top,
            width: coordinate.width,
            height: coordinate.height
        };

        if (Toolkit.pointXInRect(point, rect)) {
            return coordinate.id;
        }
    }

    return null;
}

export {
    findTargetShelf
};
